module.exports = __webpack_public_path__ + "static/media/cart.4bdb2400.webp";